 const element = document.getElementById('Details-menu-drawer-container');
 const elementRemove = document.getElementById('menu-drawer');
  const body = document.getElementsByTagName('body')[0];
  const backgroundlevel = document.getElementsByTagName('summary');

  
  // Add event listener for 'mouseenter'
  element.addEventListener('mouseenter', function() {
    // Add the class when hovered
    element.classList.add('menu-opening');
    element.setAttribute("open", true);
    body.classList.add('overflow-hidden-desktop');
  });

  // Add event listener for 'mouseleave'
  elementRemove.addEventListener('mouseleave', function() {
    // Remove the class when mouse leaves
    element.classList.remove('menu-opening');
   element.setAttribute("open", false);
    body.classList.remove('overflow-hidden-desktop');
  });


  